module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Smile-2dc5c5dcc2beb167853c274c51cb8db6.svg";